import { Id_category } from "../../api/Identifiers";
import { Category } from "../../Categories";
import { Configuration } from "../../Configuration";
import { Cookie } from "../../Cookies";
import { AssetBuildingFilterSelection } from "../../models/enums/AssetBuildingFilterSelection";
import { Action } from "../../redux/Actions";
import { dispatch_action } from "../../redux/Dispatcher";
import { get_state } from "../../redux/State";
import { exists } from "../../utils";

export class AssetFilterService {

    public expandedCategoriesCallback: Function = null;
    public filter = "";
    public trustedExpansionCategories: any= [];

    private assetStore: Category[] = [];
    private previousFilter = "";
    private originalAssetCategoryCount = new Map();
    private expanded_categories: Id_category[] = [];
    private previousCounts = new Map();
    
    public buildAssetStore(): void {
        let parentCategories: Category[] = get_state().categories.top_level_categories;
        const assetsFiltered = get_state().assetsFiltered;
        const allAssetsOnFloor = get_state().assets.get_assets_on_floor(get_state().id_floor, assetsFiltered, get_state().is_asset_filter_active);

        this.assetStore = [];
        for (let i = 0; i < parentCategories.length; i++) {
            if (parentCategories[i].is_root_parent) {
                let childCategoriesByParentCategory: Category[] = get_state().categories.get_child_categories(parentCategories[i]);
                let assetsByCategories = allAssetsOnFloor.get_assets_by_categories(childCategoriesByParentCategory, assetsFiltered);
    
                if (assetsByCategories.length === 0) {
                    continue;
                }
    
                this.originalAssetCategoryCount.set(parentCategories[i].id_category.value, assetsByCategories.validLength);
    
                for (let j = 0; j < childCategoriesByParentCategory.length; j++) {
                    let childAssetsOnFloor = allAssetsOnFloor.get_assets_by_category(childCategoriesByParentCategory[j], assetsFiltered);
    
                    if (childAssetsOnFloor.length === 0 || !exists(childCategoriesByParentCategory[j])) {
                        continue;
                    }
    
                    this.assetStore.push(childCategoriesByParentCategory[j]);
                }
    
                this.assetStore.push(parentCategories[i]);
            }
        }
    }
    
    public initializeAssetsFilter(menuRowsCount: number): void {
        if (Configuration.assetBuildingFilterSelection !== AssetBuildingFilterSelection.Assets 
            && Configuration.assetBuildingFilterSelection !== AssetBuildingFilterSelection.Both) {
            Cookie.write("assetFilter", "");
            return;
        }
    
        if (menuRowsCount < 1) {
            return;
        }
    
        let html: string = `
        <li style='padding: 2px' class='list-group-item clearfix' id="asset-search">
            <input type="search" style="width: 100%;" id="asset-search-input" placeholder="Filter Assets">
        </li>`;
    
        let li: HTMLLIElement = li_from_html(html);
    
        if (exists(document.getElementById("asset-search"))) {
            return;
        }
    
        $("#menu_assets_content_list").prepend(li);
    
        if (this.filter !== "") {
            (<HTMLInputElement>document.getElementById("asset-search-input")).value = this.filter;
            (<HTMLInputElement>document.getElementById("asset-search-input")).focus();
        }
    
        document.getElementById("asset-search-input").addEventListener("input", this.filterAssets.bind(this));
        document.getElementById("asset-search-input").dispatchEvent(new Event("input"));
    }

    public setExpandedCategories(categories: Id_category[]):void {
        this.expanded_categories = categories;
    }

    public setFilter(filter: string): void {
        this.filter = filter;
    }

    public getFilter(): string {
        return this.filter;
    }
  
    public removeChildCategories(assetCategoryId: Id_category): void {
        const assetButtonId: string = `parent-category-${assetCategoryId.value}`;
        const assetButtonsToRemove = Array.from(document.getElementsByName(assetButtonId));
    
        for (let i = 0; i < assetButtonsToRemove.length; i++) {
            assetButtonsToRemove[i].remove();
        }
    }

    public selectAllVisibleCategories(): void {
        const assetCategories = Array.from(document.querySelectorAll("[name^=parent-category]"));
        let categoryIds = assetCategories
            .filter(elem => (<HTMLElement>elem).style.display !== "none")
            .map(elem => Id_category.wrap(elem.getAttribute("id")));

        const parentCategories = Array.from(document.querySelectorAll("[name^=category_parent]"));
        const visibleParentCategoryIds = parentCategories
            .filter(elem => (<HTMLElement>elem).style.display !== "none")
            .map(elem => Id_category.wrap(elem.getAttribute("name").split("_")[2]))
            .filter(idCategory => !this.expanded_categories.includes(idCategory));

        for (let i = 0; i < visibleParentCategoryIds.length; i++) {
            for (let j = 0; j < this.assetStore.length; j++) {
                if (this.assetStore[j].root_parent === visibleParentCategoryIds[i].value) {
                    categoryIds.push(this.assetStore[j].id_category);
                }
            }
        }

        // filter to only categories with valid (filtered) assets
        const assetsFiltered = get_state().assetsFiltered;
        if (get_state().is_asset_filter_active) {
            const floor_assets = get_state().assets.get_assets_on_floor(get_state().id_floor, assetsFiltered, get_state().is_asset_filter_active);
            const validCategorySet = new Set<number>();
            floor_assets.assets.forEach((asset: any) => {
                if (asset.isValid && asset.id_category) {
                    validCategorySet.add(asset.id_category.value);
                }
            });
            categoryIds = categoryIds.filter((id: Id_category) => validCategorySet.has(id.value));
        }

        dispatch_action(Action.toggle_all_asset_categories(false));
        dispatch_action(Action.set_asset_categories_selected(categoryIds));
    }
    
    public filterAssets(this: this, event?: KeyboardEvent): void {
        if (Configuration.assetBuildingFilterSelection !== AssetBuildingFilterSelection.Assets 
            && Configuration.assetBuildingFilterSelection !== AssetBuildingFilterSelection.Both) {
            return;
        }
    
        if (exists(event)) {
            this.previousFilter = this.filter;
            this.filter = (<HTMLInputElement>event.target).value;
            Cookie.write("assetFilter", this.filter);
        }

        if (exists(event) && event.isTrusted) {
            this.trustedExpansionCategories = [];
        }

        if (this.filter === "" && this.previousFilter != "") {
            this.resetCategoryCounts();
            this.collapseExpandedCategories();
        }
    
        if (this.filter.length < 3 && this.filter !== "") {
            return;
        }

        for (let i = 0; i < this.assetStore.length; i++) {
            const assetCategoryMenuButtonId: string = `category_parent_${this.assetStore[i].root_parent}`;
    
            if (this.assetStore[i].label.toUpperCase().indexOf(this.filter.toUpperCase()) > -1) {    
                this.handleAssetCategoryThatMatchesFilter(this.assetStore[i], assetCategoryMenuButtonId);

                const matchedParentBtn = document.getElementById(assetCategoryMenuButtonId);
                if (matchedParentBtn && matchedParentBtn.parentElement && matchedParentBtn.parentElement.parentElement) {
                    matchedParentBtn.parentElement.parentElement.style.display = "";
                }
            } else {
                const assetThatMatchesFilter = this.assetStore.find((asset: Category) => (asset.root_parent === this.assetStore[i].root_parent) 
                                                        && (asset.label.toUpperCase().indexOf(this.filter.toUpperCase()) > -1));
    
                if (assetThatMatchesFilter) {
                    if (!this.parentCategoryContainsChildThatMatchesFilter(this.assetStore[i])) {
                        const elem = document.getElementById(this.assetStore[i].id_category.value.toString());

                        if (exists(elem)) {
                            elem.style.display = "none";
                        }
                    }
                    
                    continue;
                }

                this.hideItemsNotMatchingFilter(assetCategoryMenuButtonId, this.assetStore[i]);
            }
        }

        this.updateAssetCategoryCounts();
        this.expandSingleCategory();
    }

    private handleAssetCategoryThatMatchesFilter(assetCategory: Category, assetCategoryMenuButtonId: string) {
        if (this.trustedExpansionCategories.includes(assetCategory.root_parent)) {
            return;
        }

        if (assetCategory.is_root_parent()) {
            const assetThatMatchesFilter = this.assetStore.find((asset: Category) => (asset.root_parent === assetCategory.root_parent) 
                && (asset.label.toUpperCase().indexOf(this.filter.toUpperCase()) > -1) && !asset.is_root_parent());

            const parentBtn = document.getElementById(assetCategoryMenuButtonId);
            if (parentBtn && assetThatMatchesFilter && this.filter != "" && !this.expanded_categories.includes(Id_category.wrap(assetCategory.root_parent))) {
                parentBtn.click();
            }

            if (parentBtn && !assetThatMatchesFilter && this.filter != "" && this.expanded_categories.includes(Id_category.wrap(assetCategory.root_parent))) {
                parentBtn.click();
            }
        } else {
            const menuButton = document.getElementById(assetCategory.id_category.value.toString());

            if (exists(menuButton)) {
                menuButton.style.display = "";
            }

            if (!this.expanded_categories.includes(Id_category.wrap(assetCategory.root_parent)) && this.filter != "") {
                const parentCategoryBtn = document.getElementById(assetCategoryMenuButtonId);
                if (parentCategoryBtn) {
                    parentCategoryBtn.click();
                }
            }
        }
    }

    private updateAssetCategoryCounts(): void {
        let childCategoryElements = Array.from(document.querySelectorAll("[name^=parent-category]"));
        childCategoryElements = childCategoryElements.filter(elem => (<HTMLElement>elem).style.display !== "none");
    
        let assetCategoryCountsByCategoryId = new Map();
    
        for (let i = 0; i < childCategoryElements.length; i++) {
            const assetCategoryId = childCategoryElements[i].getAttribute("name").split("-")[2];
            const assetCount = +(<HTMLElement>childCategoryElements[i].children[1]).innerText;

            if (assetCategoryCountsByCategoryId.has(assetCategoryId)) {
                const updatedTotalAssetInCategoryCount = assetCategoryCountsByCategoryId.get(assetCategoryId) + assetCount;

                assetCategoryCountsByCategoryId.set(assetCategoryId, updatedTotalAssetInCategoryCount);
            } else {
                assetCategoryCountsByCategoryId.set(assetCategoryId, assetCount);
            }
        }
    
        for (let assetCategoryId of Array.from(assetCategoryCountsByCategoryId.keys())) {
            const updatedAssetCount = assetCategoryCountsByCategoryId.get(assetCategoryId);

            const assetCategoryMenuButtonId: string = `category_parent_${assetCategoryId}`;

            const parentBtn = document.getElementsByName(assetCategoryMenuButtonId)[0];
            if (parentBtn && parentBtn.children[1]) {
                (<HTMLElement>parentBtn.children[1]).innerText = updatedAssetCount;
            }
            this.previousCounts.set(assetCategoryId, updatedAssetCount);
        }

        this.updateParentCategoryCounts(assetCategoryCountsByCategoryId);
    }

    private updateParentCategoryCounts(assetCategoryCountsByCategoryId: Map<string, number>): void {
        let parentCategoryElements = Array.from(document.querySelectorAll("[name^=category_parent]"))
        parentCategoryElements = parentCategoryElements.filter(elem => (<HTMLElement>elem).style.display !== "none");

        for (let i = 0; i < parentCategoryElements.length; i++) {
            const parentCategoryId = parentCategoryElements[i].getAttribute("name").split("_")[2];
            const assetCategoryMenuButtonId: string = `category_parent_${parentCategoryId}`;
            let menuButtonToUpdate = document.getElementsByName(assetCategoryMenuButtonId)[0];
        
            if (!exists(menuButtonToUpdate)) {
                continue;
            }

            if (assetCategoryCountsByCategoryId.has(parentCategoryId)) {
                continue; // already updated by updateAssetCategoryCounts
            }

            // Parent visible but no expanded DOM children — restore original total count
            if (menuButtonToUpdate.children[1]) {
                const count = this.originalAssetCategoryCount.get(+parentCategoryId);
                if (count !== undefined) {
                    (<HTMLElement>menuButtonToUpdate.children[1]).innerText = count;
                }
            }
        }
    }

    private expandSingleCategory(): void {
        let collapsedParentCategories = Array.from(document.querySelectorAll("[name^=category_parent]"));
        collapsedParentCategories = collapsedParentCategories.filter(elem => (<HTMLElement>elem).style.display !== "none");
    
        if (collapsedParentCategories.length === 1) {
            let buttonId = collapsedParentCategories[0].getAttribute("name").split("_")[2];
        
            if (this.expanded_categories.includes(Id_category.wrap(buttonId))) {
                return;
            }

            this.trustedExpansionCategories.push(Id_category.wrap(buttonId).value);
            document.getElementById(collapsedParentCategories[0].getAttribute("name")).click();
        }
    }
    
    private parentCategoryContainsChildThatMatchesFilter(assetCategory: Category): boolean {
        const assetThatMatchesFilter = this.assetStore.find(asset => (asset.root_parent === assetCategory.root_parent) && (asset.label.toUpperCase().indexOf(this.filter.toUpperCase()) > -1));
        const parentCategory = this.assetStore.find(asset => asset.is_root_parent && asset.id_category.value === assetCategory.root_parent);
    
        if (parentCategory.label.toUpperCase().indexOf(this.filter.toUpperCase()) > -1 && assetThatMatchesFilter) {
            return true;
        }
    
        return false;
    }
    
    private hideItemsNotMatchingFilter(assetCategoryMenuButtonId: string, assetCategory: Category): void {
        const categoryId = Id_category.wrap(assetCategory.root_parent);
        if (this.expanded_categories.includes(categoryId)) {
            this.expanded_categories = this.expanded_categories.filter(c => c !== categoryId);
            this.expandedCategoriesCallback(this.expanded_categories);

            const expandedBtn = document.getElementById(assetCategoryMenuButtonId);
            if (expandedBtn) {
                expandedBtn.children[0].classList.remove("glyphicon-chevron-down");
                expandedBtn.children[0].classList.add("glyphicon-chevron-right");
            }
        }
    
        this.removeChildCategories(assetCategory.id_category);
    
        const hideBtn = document.getElementById(assetCategoryMenuButtonId);
        if (hideBtn && hideBtn.parentElement && hideBtn.parentElement.parentElement) {
            hideBtn.parentElement.parentElement.style.display = "none";
        }
    }
    
    private resetCategoryCounts(): void {
        for (let categoryId of Array.from(this.originalAssetCategoryCount.keys())) {
            const categoryCount = this.originalAssetCategoryCount.get(categoryId);
            const assetCategoryMenuButtonId: string = `category_parent_${categoryId}`;

            let categoryButtonCountLabel = document.getElementsByName(assetCategoryMenuButtonId)[0];

            if (exists(categoryButtonCountLabel)) {
                (<HTMLInputElement>categoryButtonCountLabel.children[1]).innerText = categoryCount;
            }
        }
    }
    
    private collapseExpandedCategories(): void {
        for (let i = 0; i < this.expanded_categories.length; i++) {
            const assetButtonId: string = `parent-category-${this.expanded_categories[i].value}`;
            const assetButtonsToRemove = Array.from(document.getElementsByName(assetButtonId));
        
            for (let i = 0; i < assetButtonsToRemove.length; i++) {
                assetButtonsToRemove[i].remove();
            }
    
            const assetCategoryMenuButtonId: string = `category_parent_${this.expanded_categories[i].value}`;

            const collapseBtn = document.getElementById(assetCategoryMenuButtonId);
            if (collapseBtn) {
                collapseBtn.children[0].classList.remove("glyphicon-chevron-down");
                collapseBtn.children[0].classList.add("glyphicon-chevron-right");
            }
        }
    
        this.expanded_categories = [];
        this.previousFilter = "";

        this.expandedCategoriesCallback(this.expanded_categories);
    }
}

function li_from_html(html: string): HTMLLIElement {
    return <HTMLLIElement>$.parseHTML(html.trim())[0];
}
    
                //If the parent category & child inside contains the text - expand, child - no filter
                //If the parent cateogry contains child that matches - expand, child - filter
                //If the parent category contain the text, but the inside children don't - dont expand.